export const ROOM_TYPE_OPTIONS = {
  LIVING_ROOM: 'living room',
  BEDROOM: 'bedroom',
  KITCHEN: 'kitchen',
  DINING_ROOM: 'dining room',
  KITCHEN_LIVING_COMBO: 'kitchen living combo',
  BATHROOM: 'bathroom',
  HOME_OFFICE: 'home office',
  OFFICE: 'office',
  MEETING_ROOM: 'meeting room',
  COWORKING_SPACE: 'coworking space',
  KIDS_ROOM: 'kids room',
  WALK_IN_CLOSET: 'walk-in closet',
} as const;
type ROOM_TYPE_OPTIONS_KEYS = keyof typeof ROOM_TYPE_OPTIONS;
export type TYPE_ROOM_TYPE_OPTIONS = (typeof ROOM_TYPE_OPTIONS)[ROOM_TYPE_OPTIONS_KEYS];

export const roomTypeOptions = [
  { value: ROOM_TYPE_OPTIONS.LIVING_ROOM, image: 'default-imagerendering-room_LivingRoom' },
  { value: ROOM_TYPE_OPTIONS.BEDROOM, image: 'default-imagerendering-room_Bedroom' },
  { value: ROOM_TYPE_OPTIONS.KITCHEN, image: 'default-imagerendering-room_Kitchen' },
  { value: ROOM_TYPE_OPTIONS.DINING_ROOM, image: 'default-imagerendering-room_DiningRoom' },
  {
    value: ROOM_TYPE_OPTIONS.KITCHEN_LIVING_COMBO,
    image: 'default-imagerendering-room_KitchenLivingCombo',
  },
  { value: ROOM_TYPE_OPTIONS.BATHROOM, image: 'default-imagerendering-room_Bathroom' },
  { value: ROOM_TYPE_OPTIONS.HOME_OFFICE, image: 'default-imagerendering-room_HomeOffice' },
  { value: ROOM_TYPE_OPTIONS.OFFICE, image: 'default-imagerendering-room_Office' },
  { value: ROOM_TYPE_OPTIONS.MEETING_ROOM, image: 'default-imagerendering-room_MeetingRoom' },
  { value: ROOM_TYPE_OPTIONS.COWORKING_SPACE, image: 'default-imagerendering-room_CoworkingSpace' },
  { value: ROOM_TYPE_OPTIONS.KIDS_ROOM, image: 'default-imagerendering-room_KidsRoom' },
  { value: ROOM_TYPE_OPTIONS.WALK_IN_CLOSET, image: 'default-imagerendering-room_WalkInCloset' },
];
